module.exports = __webpack_public_path__ + "img/link-arrow.f669580c.svg";